var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "profile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "profile-shape",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 18.65,15.7 C 21.19,14.21 22.9,11.54 22.9,8.48 22.9,3.81 18.91,-0 14,-0 9.09,-0 5.1,3.81 5.1,8.48 5.1,11.54 6.81,14.21 9.35,15.7 3.86,16.88 0,20.09 0,23.97 -0,27.15 8.8,28 14,28 19.2,28 28,27.15 28,23.97 28,20.09 24.14,16.88 18.65,15.7 Z M 6.93,8.48 C 6.93,4.77 10.1,1.75 14,1.75 17.9,1.75 21.07,4.77 21.07,8.48 21.07,12.2 17.9,15.22 14,15.22 10.1,15.22 6.93,12.2 6.93,8.48 Z M 14,26.25 C 6.53,26.25 2.05,24.75 1.83,23.97 1.84,20.11 7.3,16.97 14,16.97 20.7,16.97 26.16,20.11 26.17,23.97 25.95,24.74 21.48,26.25 14,26.25 Z M 14,26.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "profile-shape2",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 14,14 C 12.79,14 11.63,13.54 10.77,12.72 10.54,12.49 10.45,12.16 10.53,11.86 10.62,11.55 10.87,11.31 11.19,11.23 11.5,11.15 11.85,11.24 12.08,11.46 13.14,12.48 14.86,12.48 15.92,11.46 16.15,11.24 16.5,11.15 16.81,11.23 17.13,11.31 17.38,11.55 17.47,11.86 17.55,12.16 17.46,12.49 17.23,12.72 16.37,13.54 15.21,14 14,14 Z M 14,14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPatients);
export default __webpack_public_path__ + "static/media/menu_patients.df2b6fdbb4dc827c4365b212a3b79a19.svg";
export { ForwardRef as ReactComponent };